import { useRef } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { useButton } from 'react-aria';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './NextPage.module.scss';

const NextPage = props => {
    const intl = useIntl();
    const ref = useRef();
    const { buttonProps } = useButton({
        ...props,
        elementType: 'a'
    }, ref);

    return (
        <div
            {...buttonProps}
            className={['govuk-pagination__next', styles.item].join(' ')}
        >
            <a
                className={['govuk-link govuk-pagination__link', styles.link].join(' ')}
                rel="next"
            >
                <span className="govuk-pagination__link-title">
                    {intl.formatMessage({ id: 'pagination.next' })}
                    <span className="govuk-visually-hidden">
                        {intl.formatMessage({ id: 'pagination.page' })}
                    </span>
                </span>
                <svg className="govuk-pagination__icon govuk-pagination__icon--next"
                    xmlns="http://www.w3.org/2000/svg" height="13" width="15" aria-hidden="true"
                    focusable="false" viewBox="0 0 15 13">
                    <path
                        d="m8.107-0.0078125-1.4136 1.414 4.2926 4.293h-12.986v2h12.896l-4.1855 3.9766 1.377 1.4492 6.7441-6.4062-6.7246-6.7266z"></path>
                </svg>
            </a>
        </div>
    );
};

NextPage.propTypes = {
    ...defaultAriaProps,
    onPress: PropTypes.func
};

export default NextPage;
